import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import {
  BusinessInformation,
  PersonalInformation,
  userState,
  CoinInformation
} from './signupTypes';
import { CustomSelectOption } from '@/components/CustomSelect/CustomSelectModel';
import { RootState } from '../types';
import { IInternationalization } from '@/models/internationalization';

export const state: userState = new userState();

const actions: ActionTree<userState, RootState> = {
  SET_BUSINESS_COUNTRY(context, payload: IInternationalization) {
    context.commit('setBusinessCountry', payload);
  },
  SET_PERSONAL_INFO(context, payload: PersonalInformation) {
    context.commit('setPersonalInformation', payload);
  },
  SET_BUSINESS_INFO(context, payload: BusinessInformation) {
    context.commit('setBusinessInformation', payload);
  },
  SET_BUSINESS_CATEGORY(context, payload: string) {
    context.commit('setCategory', payload);
  },
  SET_BUSINESS_PICTURE(context, payload: string) {
    context.commit('setPictureUrl', payload);
  },
  SET_COIN_INFO(context, payload: string) {
    context.commit('setCoinInformation', payload);
  },
  RESET_STATE(context) {
    context.commit('resetState');
  }
};

const mutations: MutationTree<userState> = {
  setBusinessCountry(state, payload: IInternationalization) {
    state.businessCountry = payload;
  },
  setPersonalInformation(state, payload: PersonalInformation) {
    state.personalInformation = payload;
  },
  setBusinessInformation(state, payload: BusinessInformation) {
    state.businessInformation = { ...state.businessInformation, ...payload };
  },
  setCategory(state, payload: CustomSelectOption) {
    if (!state.businessInformation) return;
    state.businessInformation.categoryId = payload;
  },
  setPictureUrl(state, payload: string) {
    if (!state.businessInformation) return;
    state.businessInformation.logoId = payload;
  },
  setCoinInformation(state, payload: CoinInformation) {
    if (!state.businessInformation) return;
    state.coinInformation = { ...state.coinInformation, ...payload };
  },
  setPreview(state, payload: string) {
    if (!state.coinInformation) return;
    state.coinInformation.imagePreview = payload;
  },
  resetState(state) {
    Object.assign(state, new userState());
  }
};

const getters: GetterTree<userState, RootState> = {
  getAllUserInformation(state): userState {
    return state;
  },
  getCoin(state) {
    if (!state.coinInformation) return;
    return state.coinInformation;
  },
  getPreview(state) {
    if (!state.coinInformation) return;
    return state.coinInformation['imagePreview'];
  },
  getBusinessCountry(state) {
    return state.businessCountry;
  }
};

const namespaced: boolean = true;

export const signup: Module<userState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
